export default __webpack_public_path__ + "static/media/profile.9cb474e7.jpg";